<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t(type) }} </v-toolbar-title>
      <v-checkbox
        v-show="$store.state.isMainYear"
        v-model="initialPeriod"
        class="mt-6 mx-4"
        :label="$t('initialPeriod')"
        value="active"
      />
      <v-radio-group
        v-model="type"
        class="mt-6 d-none"
        row
      >
        <v-radio
          :label="$t('payCheck')"
          value="payCheck"
          :disabled="(id || formType ? true : false)"
        />
        <v-radio
          :label="$t('recieveCheck')"
          value="recieveCheck"
          :disabled="(id || formType ? true : false)"
        />
      </v-radio-group>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type + 'List') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-tabs>
        <v-tab style="height: 50px">
          {{ $t('public-information') }}
        </v-tab>
        <v-tab
          :disabled="documentPermmission"
        >
          {{ $t('documents') }}
        </v-tab>
        <v-tab-item>
          <v-container>
            <v-row>
              <v-col
                class="px-3 xs"
                cols="12"
                md="2"
                sm="2"
              >
                <autocomplete
                  v-model="account"
                  :title="(type == 'payCheck' ? $t('reciever') : $t('payer'))"
                  type="person"
                  :new-btn="true"
                  :value="account"
                />
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
                class="mb-1"
              >
                <money
                  v-model="amount"
                  :label="$t('amount')"
                  :dense="true"
                  :outlined="true"
                  :solo="false"
                  :clearable="true"
                  value-when-is-empty=""
                  :disabled="amountDisable"
                  :options="options"
                  :rules="rule"
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="2"
              >
                <template>
                  <v-text-field
                    id="dueDateId"
                    v-model="dueDate"
                    :label="$t('dueDate')"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                    :disabled="dueDateDisable"
                    @keyup="dueDate = null"
                  />
                  <date-picker
                    v-model="dueDate"
                    element="dueDateId"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="2"
              >
                <template>
                  <v-text-field
                    id="from"
                    v-model="date"
                    :label="$t('date') + ' ' + $t('issue')"
                    :rules="[v => !!v || $t('is-required')]"
                    clear-icon="flaticon2-close-cross"
                    outlined
                    dense
                    clearable
                  />
                  <date-picker
                    v-model="date"
                    element="from"
                    :locale="$store.state.date_locale"
                    :format="$store.state.date_format"
                    auto-submit
                    :min="$store.state.startDate"
                    :max="$store.state.endDate"
                    :color="this.$vuetify.theme.themes[this.$vuetify.theme.isDark ? 'dark' : 'light'].primary"
                    @close="setDate"
                  />
                </template>
              </v-col>
              <v-col
                cols="12"
                sm="2"
                md="2"
              >
                <v-select
                  v-model="kind"
                  :label="$t('kind') + ' ' + $t('check')"
                  :items="kindItems"
                  height="30"
                  dense
                  outlined
                  :disabled="kindDisable"
                  item-value="value"
                  item-text="text"
                />
              </v-col>
              <v-col
                v-if="type == 'recieveCheck'"
                cols="12"
                md="2"
                sm="2"
                class="mb-0  "
              >
                <v-text-field
                  v-model="number"
                  :label="$t('number') + ' ' + $t('check')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                cols="12"
                md="2"
                sm="2"
                class="mb-0  "
              >
                <v-text-field
                  v-model="fishermanNumber"
                  :label="$t('fishermanNumber')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                v-if="type == 'payCheck'"
                cols="12"
                sm="4"
                md="4"
              >
                <autocomplete
                  v-model="check"
                  :rules="[v => !!v || $t('is-required')]"
                  :title="$t('check')"
                  type="payCheck"
                  :value="check"
                />
              </v-col>
              <v-col
                v-if="type == 'recieveCheck'"
                cols="12"
                md="2"
                sm="2"
                class="mb-0  "
              >
                <v-text-field
                  v-model="bankName"
                  :label="$t('name') + ' ' + $t('bank')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                v-if="type == 'recieveCheck'"
                cols="12"
                md="2"
                sm="2"
                class="mb-0  "
              >
                <v-text-field
                  v-model="bankAccountNumber"
                  :label="$t('number') + ' ' + $t('account')"
                  height="20"
                  dense
                  outlined
                  class="mb-1 dense"
                  clearable
                />
              </v-col>
              <v-col
                v-if="type == 'recieveCheck'"
                cols="12"
                sm="2"
                md="2"
              >
                <autocomplete
                  v-model="cashBox"
                  :title="$t('cashBox')"
                  type="getCash"
                  :currency-prop="(currency ? currency.id : $store.state.currency.id)"
                  :value="cashBox"
                />
              </v-col>
            </v-row>
            <v-expansion-panels
              v-model="panel"
              class="mt-7 px-0"
            >
              <v-expansion-panel>
                <v-expansion-panel-header>
                  {{ $t('otherInputs') }}
                  ✏️
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                    >
                      <aicomplete
                        v-model="branch"
                        title="branch"
                        type="branch"
                        :set-init="true"
                        :val="branch"
                        :new-btn="true"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                    >
                      <autocomplete
                        ref="refCurrency"
                        v-model="currency"
                        :rules="[v => !!v || $t('is-required')]"
                        :title="$t('currency')"
                        type="currency"
                        :init="defaultCurrency"
                        :value="currency"
                        :disabled="(type == 'payCheck' ? true : false)"
                        @change="changeCurrency"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="2"
                      md="2"
                    >
                      <money
                        v-model="currency_amount"
                        :label="$t('currency-rate')"
                        :dense="true"
                        :outlined="true"
                        :solo="false"
                        :clearable="true"
                        value-when-is-empty=""
                        :disabled="currencyAmountDisable"
                        :options="options"
                        :rules="rule"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                      sm="6"
                    >
                      <tag
                        v-model="tag"
                        :solo="false"
                        :input="tag"
                      />
                    </v-col>
                    <v-col
                      v-if="!initialPeriod"
                      class="px-3 xs"
                      cols="12"
                      md="6"
                      sm="6"
                    >
                      <autocomplete
                        ref="refRelations"
                        v-model="relations"
                        :multiple="true"
                        :value="[]"
                        :disabled="(!account || relationsDisable? true : false)"
                        :data="JSON.stringify({refId : (account ? account.id :null), currency_id : (currency ? currency.id : null)})"
                        :title="$t('relative-document')"
                        :type="(type == 'payCheck' ? 'receiptInvoice' : 'remittanceInvoice')"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      md="6"
                    >
                      <description
                        ref="refContent"
                        v-model="content"
                        :outlined="true"
                        type="sell"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                    >
                      <notification
                        v-model="notifications"
                        :value="notifications"
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-container>
        </v-tab-item>
        <v-tab-item>
          <v-row class="mx-0 pt-2">
            <v-col
              cols="12"
              md="3"
              sm="3"
            >
              <file-picker
                ref="refFilePicker"
                v-model="attachments"
                :label="$t('addDocuments')"
                :multiple="true"
                type-prop="check"
                :val="(id && attachments ? attachments : null)"
              />
            </v-col>
          </v-row>
        </v-tab-item>
      </v-tabs>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
              v-shortkey="['shift','f3']"
              @shortkey="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              v-shortkey="['shift','f3']"
              @shortkey="update"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              v-if="!formType"
              color="grey"
              outlined
              class="float-left"
              @click="goTo( type + 'List' )"
            >
              {{ $t(type + 'List') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-divider />
      <v-card-actions v-if="!isMobile">
        <v-row
          class="ma-0 mx-2"
          style="color: #6e6e6e;font-size: 12px"
        >
          {{ $t('shortcuts') }} <strong>⌨️</strong> :  {{ $t('submit') }} = shift+f3
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Description from '../../components/general/description/Description'
  import filePicker from '../../components/general/filePicker/index'
  export default {
    name: 'Product',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      // aicomplete,
      filePicker,
      Description,
      Tag: () => import('../../components/general/Tag/tag'),
    },
    mixins: [General],
    props: ['formType', 'accountProp', 'typeProp', 'notStore'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      cashBox: null,
      initialPeriod: null,
      fishermanNumber: null,
      notifications: null,
      attachments: null,
      account: null,
      date: null,
      check: null,
      dueDate: null,
      tag: null,
      content: null,
      valid: null,
      message: null,
      alertType: null,
      bankAccountNumber: null,
      amount: 0,
      relations: null,
      name: null,
      id: null,
      currency: null,
      currency_amount: null,
      status: 'active',
      branch: null,
      bankName: null,
      kind: 'normal',
      kindItems: [],
      number: null,
      type: 'bank',
      amountDisable: false,
      kindDisable: false,
      relationsDisable: false,
      currencyAmountDisable: false,
      dueDateDisable: false,
      initial_price: null,
      loading: false,
    }),
    computed: {
      rule () {
        return [
          v => (v && v.replaceAll(',', '') > 0) || this.$t('TheAmountMustBeBiggerThanZero'),
        ]
      },
    },
    watch: {
      defaultCurrency () {
        if (this.defaultCurrency) {
          this.$refs.refCurrency.setModel(this.defaultCurrency)
          this.currency_amount = this.defaultCurrency.amount
        }
      },
      check () {
        if (this.check) {
          this.currency = this.check.currency
        } else {
          this.currency = null
        }
        if (this.$refs.refRelations) {
          this.$refs.refRelations.clear()
          this.$refs.refRelations.initList = false
          this.$refs.refRelations.getItems({ query: null, page: 1 })
        }
        if (this.check.type === 'customer') {
          this.dueDate = this.check.due_date
          this.amount = this.check.amount
          this.kind = this.check.kind
          this.content = this.check.content
          this.amountDisable = true
          this.kindDisable = true
          this.dueDateDisable = true
          this.currencyAmountDisable = true
          this.tag = this.check.tags
          if (this.check.relations.length > 0) {
            this.relations = this.check.relations
            this.relationsDisable = true
          }
        } else {
          this.amountDisable = false
          this.kindDisable = false
          this.dueDateDisable = false
          this.currencyAmountDisable = false
          this.relationsDisable = false
        }
      },
      currency (val, old) {
        if (val) {
          this.currency_amount = val.amount
          this.options.suffix = val.symbol
        } else {
          this.options.suffix = ' '
          this.currency_amount = null
        }
        if (this.$refs.refRelations) {
          this.$refs.refRelations.clear()
          this.$refs.refRelations.initList = false
          this.$refs.refRelations.getItems({ query: null, page: 1 })
        }
      },
      account () {
        if (this.$refs.refRelations) {
          this.$refs.refRelations.clear()
          this.$refs.refRelations.initList = false
          this.$refs.refRelations.getItems({ query: null, page: 1 })
        }
      },
    },
    beforeMount () {
      if (this.$route.name === 'payCheck') {
        this.type = 'payCheck'
      } else {
        this.type = 'recieveCheck'
      }
      if (this.formType) {
        this.type = this.formType
      }
      this.setInitProp()

      if (this.$route.params.id != null && !this.accountProp) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
        this.setInitCurrency()
        // this.defaultCurrency = this.getDefault('defaultCurrency')
      }
    },
    mounted () {
      this.kindItems = [
        {
          value: 'normal',
          text: this.$t('normal'),
        },
        {
          value: 'guarantee',
          text: this.$t('guarantee'),
        },
      ]
    },
    methods: {
      setInitProp () {
        if (this.accountProp) {
          this.account = this.accountProp
        }
        if (this.typeProp) {
          this.type = this.typeProp
        }
      },
      changeCurrency () {
        this.bankRemain = 0
        this.currency_amount = this.currency.amount
        this.options = {
          locale: 'en-US',
          prefix: '',
          suffix: this.currency.symbol,
          precision: 0,
        }
      },
      create () {
        if (!this.$refs.form.validate()) return false
        var app = this
        app.alert = false
        if (this.notStore) {
          const copy = Object.assign({}, this.$data)
          app.$emit('get', copy)
          app.$emit('close')
          this.clearForm()
          this.setInitProp()
        } else {
          app.isLoading = true
          app.$axios.post(this.$endpoint + 'checks', app.$data)
            .then(res => {
              res = res.data
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
              if (app.$refs.refFilePicker !== undefined && app.attachments) {
                app.$refs.refFilePicker.create(res.data.id)
              }
              if (app.id) {
              } else {
                app.$emit('input', res.data.data)
              }
              app.goTo(app.type + 'List')
            })
            .catch(err => {
              this.serverErrorHandeler(err)
            })
            .finally(() => {
              this.isLoading = false
              // this.clearForm()
            })
        }
      },
      show () {
        var app = this
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'checks/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              if (res.type === 'own') {
                app.type = 'payCheck'
                app.check = res.page
              } else {
                app.type = 'recieveCheck'
              }
              app.typeForm = res.type
              app.id = res.id
              app.attachments = res.attachments
              app.fishermanNumber = res.fisherman_number
              app.account = res.account
              app.cashBox = res.cashbox
              app.bank = res.bank
              app.initialPeriod = res.initial_period
              app.kind = res.kind
              app.number = res.number
              app.date = res.date
              app.dueDate = res.due_date
              app.notifications = res.notifications
              app.branch = res.branch
              app.amount = res.amount
              app.bankName = res.bank_name
              app.bankAccountNumber = res.bank_account_number
              app.relations = res.relations
              app.currency = res.currency
              app.currency_amount = res.currency_amount
              app.content = res.content
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'checks/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            if (app.$refs.refFilePicker !== undefined) {
              app.$refs.refFilePicker.create(res.data.id)
            }
            app.$emit('close', app.$route)
            app.goTo(app.type + 'List')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      clearForm () {
        this.initialPeriod = null
        this.attachments = null
        this.account = null
        // this.date = null
        this.check = null
        this.dueDate = null
        this.tag = null
        this.content = null
        this.valid = null
        this.message = null
        this.alertType = null
        this.bankAccountNumber = null
        this.amount = null
        this.relations = null
        this.name = null
        this.id = null
        this.currency_amount = null
        this.status = 'active'
        this.branch = null
        this.bankName = null
        this.number = null
        this.amountDisable = false
        this.kindDisable = false
        this.relationsDisable = false
        this.currencyAmountDisable = false
        this.dueDateDisable = false
        this.initial_price = null
        this.$refs.form.resetValidation()
      },
    },
  }
</script>

<style scoped>

</style>
